let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8tZDL")).then(() => parcelRequire('eO3nF'));